import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { AppLayout } from '@/components/layouts/AppLayout';
import { FullPageSpinner } from '@/components/ui/full-page-spinner';
import { FullPageError } from '@/components/ui/full-page-error';

export const Route = createFileRoute('/_dashboard')({
  beforeLoad: async ({ context }) => {
    // When auth is still loading, skip the guard — AppLayout shows its own spinner and
    // waits for Clerk to settle before fetching /auth/me.
    // Only redirect when we have a definitive unauthenticated state.
    if (!context.auth.isLoading && !context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppLayout,
  pendingComponent: DashboardPending,
  errorComponent: DashboardError,
});

function DashboardPending() {
  return <FullPageSpinner />;
}

function DashboardError({ error }: { error: Error }) {
  const navigate = useNavigate();
  return (
    <FullPageError
      title="Something went wrong"
      description={error.message}
      actionLabel="Back to Sequences"
      onAction={() => navigate({ to: '/sequences' })}
    />
  );
}
